export default __webpack_public_path__ + "static/media/caretDown.b48eb952.svg";